import { defineComponent } from 'vue';
import BackgroundComponent from '../../components/background/Background.vue';

export default defineComponent({
  name: 'NotFoundPage',
  components: {
    BackgroundComponent
  }
});

